// extracted by mini-css-extract-plugin
export default {"wrapper":"WeatherCards_wrapper__GjsXt"};